import { createFileRoute } from '@tanstack/react-router';
import { guardAutomationsSection } from './-guard';
import { AutomationsSection } from './-section';

/**
 * @desc The admin automations section — Ario on the platform build (H2-7;
 * add-ario-identity-and-authoring-round-3 D1, D2): Chat, Workflows, Collectors, Processors,
 * Schedules, Runs and Outputs, under `/admin/ario/*` on both builds. Rendered inside the admin
 * layout, so every page scrolls in the admin page scroller (`data-page-scroller="admin"`, already
 * in the router's `scrollToTopSelectors`) and only admins reach it. The old `/admin/automations/*`
 * paths redirect here (`../automations/$.tsx`).
 */
export const Route = createFileRoute('/_protected/admin/ario')({
  beforeLoad: guardAutomationsSection,
  component: AutomationsSection,
});
